

let search_timeout
let search_form = $('.js-search-form')
let search_input = $('.js-search-input')
let search = $('.js-search')
let clear = $('.js-search-close')

search.click(function(){
  search_form.submit()
})

function getSearchResults () {
  let loader = $('.js-search-loader')
  let val = search_input.val()
  let results_c = $('.quick-search')
  let results = $('.js-quick-search')
  let search_form = $('.search-input-c')

  if (val.length >= 2) {
    clear.fadeIn()
    search.css('display', 'none')
    loader.fadeIn(100)

    $.ajax({
      url: localize_script['ajax_url'],
      type:'POST',
      data:'action=quick-search&s='+ val,
      success:function(response){
        loader.css('display', 'none')
        search.fadeIn(200)
        results.html($(response))
        search_form.addClass('results-opened')
        results_c.fadeIn(200, function(){
          let height = results_c.offset().top + results_c.height() + 150
          $('.js-search-popup .popup-c').css('min-height', height)
        })
      }
    });

  } else {
    clearSearch()
  }
}

function clearSearch () {
  let results_c = $('.quick-search')
  let search_form = $('.search-input-c')
  clear.fadeOut()
  results_c.fadeOut()
  search_form.removeClass('results-opened')
  $('.js-search-popup .popup-c').css('min-height', 'auto')
}

function restartTimer () {
  clearTimeout(search_timeout);
  search_timeout = setTimeout(getSearchResults, 450);
}

search_input.on('input', restartTimer)

clear.click(function () {
  clearSearch()
  search_input.val('')
  search_input.focus()
})